import { motion } from "framer-motion";
import styled from "styled-components";

import { colourScheme } from "utils/styling/colours"; // Adjust the import path as needed

export const StatsContainer = styled.div`
    padding: 2rem;
    border-radius: 0.75rem;
    background-color: ${colourScheme.primaryDark};
`;

export const StatsTitle = styled.h2`
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
    color: ${colourScheme.white};
`;

export const StatsGrid = styled.div`
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
`;

export const StatCard = styled(motion.div)`
    background-color: ${colourScheme.primary};
    background-image: linear-gradient(
        to bottom right,
        ${colourScheme.primary},
        ${colourScheme.primaryLight}
    );
    border-radius: 0.5rem;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colourScheme.white};
    box-shadow:
        0 4px 6px ${colourScheme.shadow},
        0 1px 3px ${colourScheme.shadow};
    transition:
        transform 0.2s,
        box-shadow 0.2s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 30px -15px ${colourScheme.shadow};
    }
`;
export const StatIcon = styled.div`
    width: 2rem; /* Equivalent to w-8 */
    height: 2rem; /* Equivalent to h-8 */
    margin-bottom: 0.5rem; /* Equivalent to mb-2 */
    color: ${colourScheme.secondaryLight};

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const StatValue = styled.span`
    font-size: 1.5rem; /* Equivalent to text-2xl */
    font-weight: bold;
    color: ${colourScheme.secondary};
`;

export const StatLabel = styled.span`
    font-size: 0.875rem; /* Equivalent to text-sm */
    text-align: center;
    color: ${colourScheme.greyLight};
`;
